import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "stepper-navigation mb-6" }
const _hoisted_2 = { class: "stepper-steps" }
const _hoisted_3 = { class: "stepper-step-number" }
const _hoisted_4 = { class: "stepper-step-label" }
const _hoisted_5 = { class: "stepper-content" }

import { ref, provide, type Ref } from 'vue';
    // @ts-expect-error raison: lib externe mal typée
    

    export interface CustomStepperStepEntry {
        uid: number;
        title: string;
    }

    export interface CustomStepperContext {
        steps: Ref<CustomStepperStepEntry[]>;
        activeIndex: Ref<number>;
        registerStep: (step: CustomStepperStepEntry) => void;
        unregisterStep: (uid: number) => void;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomStepper',
  props: {
    activeStep: { default: 0 }
  },
  emits: ["update:activeStep"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

    const props = __props;
    const emit = __emit;

    const steps = ref<CustomStepperStepEntry[]>([]);
    const activeIndex = ref(props.activeStep);

    function registerStep(step: CustomStepperStepEntry) {
        steps.value.push(step);
    }

    function unregisterStep(uid: number) {
        steps.value = steps.value.filter((step) => step.uid !== uid);
    }

    function goTo(index: number) {
        if (index < 0 || index >= steps.value.length) return;
        activeIndex.value = index;
        emit('update:activeStep', index);
    }

    function next() {
        goTo(activeIndex.value + 1);
    }

    function previous() {
        goTo(activeIndex.value - 1);
    }

    provide<CustomStepperContext>('customStepper', { steps, activeIndex, registerStep, unregisterStep });

    __expose({ next, previous, goTo, activeIndex });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(steps.value, (step, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: step.uid
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["stepper-step", { active: activeIndex.value === index, completed: activeIndex.value > index }])
            }, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(index + 1), 1),
              _createElementVNode("div", _hoisted_4, _toDisplayString(step.title), 1)
            ], 2),
            (index < steps.value.length - 1)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["stepper-line", { completed: activeIndex.value > index }])
                }, null, 2))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 64))
}
}

})